var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uploadList',{attrs:{"limit":11,"uploadSize":"2gb","accept":['.mp4','.mov']}})
}
var staticRenderFns = []

export { render, staticRenderFns }